import React, { useContext ,useEffect} from 'react'
import { Context } from "../context/Context"
import { duaData } from "../Database/Database"
import { Link } from "react-router-dom";
import { SendGuiDataEvents } from '../lib/CommonScript';

export default function Dua() {

  const { lang,theme } = useContext(Context);
  // handle previous path
  useEffect(() =>{
    localStorage.setItem("prevPath","quran_detail");
  },[])

  useEffect(() => {
    //send gui events
    let guiDataEvent = {};
    guiDataEvent["w_action"] = "card_click";
    guiDataEvent["name"] = "dua";
    SendGuiDataEvents(guiDataEvent);
  }, []);




  return (
    <div className={`min-h-screen h-full  bg-cover bg-center bg-no-repeat  ${theme === "red" ? "bg-red_bg_pic": "bg-green_bg_pic"} pt-20 max-width`}>
      <div className='flex flex-col justify-between text-white w-3/4 mx-auto h-85v'>
        <div className={` ${theme === "red" ? "bg-red_surah_scroll_header": "bg-surah_scroll_header"} bg-contain h-16 bg-no-repeat my-0`}></div>
        <div className='h-full  w-full bg-smoke-lighter ml-1 -mt-5 px-auto my-0 overflow-y-auto'>
          {
            duaData && duaData[lang].map((data, index) => {
              return (
                <div key = {index} className=' w-full'>
                  <Link to={{pathname :`/dua_detail/${index}`, state : {heading : data}}} >
                    <div className={`${theme === "red" ? "bg-red_surah_name_board": "bg-surah_name_board text-black"}  bg-75% h-10 bg-center bg-no-repeat w-full py-2`}>
                        <div className='flex flex-row justify-between px-16'>
                          <div className='ml-2 font-bold text-lg'>{index+1 +"."}</div>
                          <div className='w-full -ml-3 ' dir='rtl'> {data}</div>
                        </div>
                    </div>
                  </Link>
                </div>

              )
            })
          }
        </div>
        <div className={`${theme === "red" ? "bg-red_surah_scroll_footer": "bg-surah_scroll_footer"}  bg-contain h-16 bg-no-repeat`}></div>
      </div>
    </div>
  )
}
